import React, { useEffect, useState } from "react";
import {
  useNavigate,
  useLocation,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Sidebar from "../common/Sidebar";
import MainContainer from "../MainContainer";
import { BankNameProvider } from "../../context/BankNameContext";
import { useDispatch, useSelector } from "react-redux";
import { openSidebar, toggleSidebar } from "../store/toggleSidebar";
import Header from "../common/Headers";

const ProtectedLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeParentRoute, setActiveParentRoute] = useState({});
  const [activeChildRoute, setActiveChildRoute] = useState({});
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      // setIsMobileView(window.innerWidth);
      const viewportWidth = window.innerWidth / window.devicePixelRatio;
      setIsMobileView(viewportWidth);

      if (window.innerWidth > 768) {
        dispatch(openSidebar());
      } else {
        setIsMobileView(true);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen);

  const handleToggleSidebar = () => {
    if (isMobileView) {
      dispatch(toggleSidebar());
    }
  };

  return (
    <BankNameProvider>
      <div className="app-container pl-3">
        {/* <Header analytics={{}} /> */}
        <Header />
        <div className="main-content">
          {/* {(isSidebarOpen || isMobileView > 768) && (
            <Sidebar
              activeRoute={activeParentRoute}
              setActiveRoute={setActiveParentRoute}
              handleToggleSidebar={handleToggleSidebar}
            />
          )} */}
          <Routes>
            <Route
              path="/*"
              element={
                <MainContainer
                  title={activeChildRoute?.name || activeParentRoute?.name}
                  handleToggleSidebar={handleToggleSidebar}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </BankNameProvider>
  );
};

export default ProtectedLayout;
